import { contentApi } from '../../infrastructure/Configuration'
import TripAdvisorRating from '../domain/TripAdvisorRating'
import TripAdvisorReview from '../domain/TripAdvisorReview'
import TripAdvisor from '../domain/TripAdvisor'

export default class TripAdvisorService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  getRatingAndReviewsForHotel = (hotelCode) => Promise.all([this._getHotelRating(hotelCode), this._getHotelReviews(hotelCode)])
    .then((data) => ({ rating: data[0], reviews: data[1] }))
    .then(({ rating, reviews }) => new TripAdvisor({ rating, reviews }))

  _getHotelRating = async (hotelCode) => {
    const url = `${contentApi}/hotels/${hotelCode}/rating`
    const { data } = await this.httpClient.get(url)
    return TripAdvisorRating.fromJSON(data || {})
  }

  _getHotelReviews = async (hotelCode) => {
    const url = `${contentApi}/hotels/${hotelCode}/reviews`
    const { data: { reviews } } = await this.httpClient.get(url)
    return (reviews || []).map(TripAdvisorReview.fromJSON)
  }
}
